import { Component, Input, ChangeDetectionStrategy } from "@angular/core"

@Component({
  selector: "flow-badge-v2",
  templateUrl: "./flow-badge-v2.component.html",
  styleUrl: "./flow-badge-v2.component.scss",
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class FlowBadgeV2Component {
  @Input() text: string = ""
  @Input() color: AgColor = "Neutral"
  @Input() size: AgSize = "Small"
  @Input() type: AgType = "Solid"
  @Input() icon: string = ""
}

export type AgSize = "Small" | "Large"
export type AgType = "Solid" | "Subtle"
export type AgColor = "Neutral" | "Info1" | "Destructive" | "Success" | "Warning1" | "Warning2" | "Info2"
